<div class="col-12 tp-txtpg">
    <h3>Hi {{userName$ | async}}!</h3>
</div>